export { HoverSection } from './hover-section';
export type { HoverSectionProps } from './hover-section';
